const commsToLinesResp = {
    error: null,
    overall: {
        value: 0.3114402857134565,
        significance: "moderate",
        explanation:
            "They are moderately positively correlated, potentially meaning that days that you spend a high amount of time on communications may occasionally be also the days you commit more as well.",
        description:
            "For the entirety of time we have data on your communications and commits, it seems that there is n moderately strong positive correlation between the time spent in meetings and chats and the amount of code produced.that on days that you spend a high amount of time in communications are occassionaly also the days that the most lines of code are committed, and vice versa.However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it.",
        error: null,
    },
    smaller_frame: {
        value: 0.7811189063708478,
        significance: "very strong",
        explanation:
            "They are very highly positively correlated, potentially meaning that days that you spend a high amount of time on communications have a very high chance to be the days you commit many lines of code as well.",
        description:
            "For last 2 weeks, it seems that there is n very strong positive correlation between the time spent in meetings and chats and the amount of code produced.that on days that you spend a high amount of time in communications are also the days that the most lines of code are committed, and vice versa.However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And therefore it might be the case that the extended level of communications helps produce more code (or you just commit it these days).",
        frame_name: "Last 2 weeks",
        error: null,
    },
    graph: {
        data: [
            {
                datetime: "2023-04-24T00:00:00.000",
                comms: 7776.0,
                total: 43.0,
                correlation: 0.6452011063,
                trend_line: 3340.2362900209,
            },
            {
                datetime: "2023-04-25T00:00:00.000",
                comms: 9373.0,
                total: 16.0,
                correlation: 0.655030627,
                trend_line: 4459.0343374074,
            },
            {
                datetime: "2023-04-26T00:00:00.000",
                comms: 11351.0,
                total: 3.0,
                correlation: 0.4943877167,
                trend_line: 5800.9017624956,
            },
            {
                datetime: "2023-04-27T00:00:00.000",
                comms: 5388.0,
                total: 0.0,
                correlation: 0.4771652155,
                trend_line: 1779.7990338322,
            },
            {
                datetime: "2023-04-28T00:00:00.000",
                comms: 6060.0,
                total: 0.0,
                correlation: 0.4546141096,
                trend_line: 2193.7368751652,
            },
            {
                datetime: "2023-04-29T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4619086636,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-04-30T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4683335227,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-01T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.4676636738,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-05-02T00:00:00.000",
                comms: 5168.0,
                total: 467.0,
                correlation: 0.1376897711,
                trend_line: 1650.1156330662,
            },
            {
                datetime: "2023-05-03T00:00:00.000",
                comms: 7718.0,
                total: 27.0,
                correlation: 0.1318189032,
                trend_line: 3300.0625292536,
            },
            {
                datetime: "2023-05-04T00:00:00.000",
                comms: 6072.0,
                total: 0.0,
                correlation: 0.1221587333,
                trend_line: 2201.3501252811,
            },
            {
                datetime: "2023-05-05T00:00:00.000",
                comms: 5172.0,
                total: 33.0,
                correlation: 0.1090599332,
                trend_line: 1652.4455173459,
            },
            {
                datetime: "2023-05-06T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1090599332,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-07T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1202505997,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-08T00:00:00.000",
                comms: 7125.0,
                total: 298.0,
                correlation: 0.1914283301,
                trend_line: 2893.7887965452,
            },
            {
                datetime: "2023-05-09T00:00:00.000",
                comms: 8251.0,
                total: 550.0,
                correlation: 0.2949776086,
                trend_line: 3671.3143395824,
            },
            {
                datetime: "2023-05-10T00:00:00.000",
                comms: 6642.0,
                total: 242.0,
                correlation: 0.3271775804,
                trend_line: 2570.6745685167,
            },
            {
                datetime: "2023-05-11T00:00:00.000",
                comms: 6891.0,
                total: 146.0,
                correlation: 0.3283515996,
                trend_line: 2736.2292268971,
            },
            {
                datetime: "2023-05-12T00:00:00.000",
                comms: 5455.0,
                total: 113.0,
                correlation: 0.3060350177,
                trend_line: 1819.9001435348,
            },
            {
                datetime: "2023-05-13T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3066978344,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-14T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3499106337,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-15T00:00:00.000",
                comms: 8618.0,
                total: 659.0,
                correlation: 0.4718562412,
                trend_line: 3928.8001987305,
            },
            {
                datetime: "2023-05-16T00:00:00.000",
                comms: 6270.0,
                total: 444.0,
                correlation: 0.6105104238,
                trend_line: 2327.9799952356,
            },
            {
                datetime: "2023-05-17T00:00:00.000",
                comms: 13170.0,
                total: 95.0,
                correlation: 0.5016464957,
                trend_line: 6879.4784034923,
            },
            {
                datetime: "2023-05-18T00:00:00.000",
                comms: 8624.0,
                total: 178.0,
                correlation: 0.5142150549,
                trend_line: 3933.0162405452,
            },
            {
                datetime: "2023-05-19T00:00:00.000",
                comms: 5125.0,
                total: 10.0,
                correlation: 0.4835777874,
                trend_line: 1625.1364689568,
            },
            {
                datetime: "2023-05-20T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4835777874,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-21T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.5007189906,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-22T00:00:00.000",
                comms: 5859.0,
                total: 18.0,
                correlation: 0.5155344085,
                trend_line: 2067.3093494323,
            },
            {
                datetime: "2023-05-23T00:00:00.000",
                comms: 5100.0,
                total: 84.0,
                correlation: 0.5477535524,
                trend_line: 1610.6705046145,
            },
            {
                datetime: "2023-05-24T00:00:00.000",
                comms: 7229.0,
                total: 276.0,
                correlation: 0.5782529153,
                trend_line: 2964.3681276092,
            },
            {
                datetime: "2023-05-25T00:00:00.000",
                comms: 6283.0,
                total: 56.0,
                correlation: 0.5708969765,
                trend_line: 2336.3589397131,
            },
            {
                datetime: "2023-05-26T00:00:00.000",
                comms: 5038.0,
                total: 22.0,
                correlation: 0.5438215467,
                trend_line: 1574.9772729268,
            },
            {
                datetime: "2023-05-27T00:00:00.000",
                comms: 300.0,
                total: 0.0,
                correlation: 0.5436735829,
                trend_line: -52.1428697432,
            },
            {
                datetime: "2023-05-28T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.5545990049,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-05-29T00:00:00.000",
                comms: 4200.0,
                total: 9.0,
                correlation: 0.5293886416,
                trend_line: 1120.1494476177,
            },
            {
                datetime: "2023-05-30T00:00:00.000",
                comms: 4200.0,
                total: 0.0,
                correlation: 0.5184066989,
                trend_line: 1120.1494476177,
            },
            {
                datetime: "2023-05-31T00:00:00.000",
                comms: 7872.0,
                total: 3.0,
                correlation: 0.4751149196,
                trend_line: 3406.8685322676,
            },
            {
                datetime: "2023-06-01T00:00:00.000",
                comms: 5132.0,
                total: 1.0,
                correlation: 0.4672097612,
                trend_line: 1629.1944483043,
            },
            {
                datetime: "2023-06-02T00:00:00.000",
                comms: 4200.0,
                total: 3.0,
                correlation: 0.455796246,
                trend_line: 1120.1494476177,
            },
            {
                datetime: "2023-06-03T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.455796246,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-04T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4338533437,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-05T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.5489109446,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-06-06T00:00:00.000",
                comms: 7200.0,
                total: 1.0,
                correlation: 0.5055282538,
                trend_line: 2944.6551764465,
            },
            {
                datetime: "2023-06-07T00:00:00.000",
                comms: 4560.0,
                total: 6.0,
                correlation: 0.3966094992,
                trend_line: 1308.9612575161,
            },
            {
                datetime: "2023-06-08T00:00:00.000",
                comms: 7188.0,
                total: 12.0,
                correlation: 0.3772635319,
                trend_line: 2936.5052779907,
            },
            {
                datetime: "2023-06-09T00:00:00.000",
                comms: 8086.0,
                total: 52.0,
                correlation: 0.3778549853,
                trend_line: 3555.9472039118,
            },
            {
                datetime: "2023-06-10T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3778549853,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-11T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3950137531,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-12T00:00:00.000",
                comms: 8719.0,
                total: 2.0,
                correlation: 0.3365005691,
                trend_line: 3999.7843757627,
            },
            {
                datetime: "2023-06-13T00:00:00.000",
                comms: 11044.0,
                total: 57.0,
                correlation: 0.5849320524,
                trend_line: 5600.8820036708,
            },
            {
                datetime: "2023-06-14T00:00:00.000",
                comms: 12035.0,
                total: 66.0,
                correlation: 0.711564698,
                trend_line: 6230.1964044588,
            },
            {
                datetime: "2023-06-15T00:00:00.000",
                comms: 6459.0,
                total: 68.0,
                correlation: 0.6608776345,
                trend_line: 2450.5446228875,
            },
            {
                datetime: "2023-06-16T00:00:00.000",
                comms: 5057.0,
                total: 427.0,
                correlation: 0.1708648149,
                trend_line: 1585.8877323668,
            },
            {
                datetime: "2023-06-17T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1708648149,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-18T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1853805933,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-19T00:00:00.000",
                comms: 3946.0,
                total: 12.0,
                correlation: 0.185521073,
                trend_line: 993.4100669951,
            },
            {
                datetime: "2023-06-20T00:00:00.000",
                comms: 6256.0,
                total: 20.0,
                correlation: 0.2000954369,
                trend_line: 2318.9652446931,
            },
            {
                datetime: "2023-06-21T00:00:00.000",
                comms: 9863.0,
                total: 52.0,
                correlation: 0.2039391891,
                trend_line: 4800.5684062091,
            },
            {
                datetime: "2023-06-22T00:00:00.000",
                comms: 5863.0,
                total: 5.0,
                correlation: 0.1958289701,
                trend_line: 2069.8046789514,
            },
            {
                datetime: "2023-06-23T00:00:00.000",
                comms: 4322.0,
                total: 35.0,
                correlation: 0.1763199219,
                trend_line: 1182.9626208191,
            },
            {
                datetime: "2023-06-24T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1763199219,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-25T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1897802348,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-06-26T00:00:00.000",
                comms: 6468.0,
                total: 186.0,
                correlation: 0.2219245793,
                trend_line: 2456.4200908306,
            },
            {
                datetime: "2023-06-27T00:00:00.000",
                comms: 8584.0,
                total: 139.0,
                correlation: 0.2503092636,
                trend_line: 3904.9118542214,
            },
            {
                datetime: "2023-06-28T00:00:00.000",
                comms: 9610.0,
                total: 146.0,
                correlation: 0.299754247,
                trend_line: 4624.6597902179,
            },
            {
                datetime: "2023-06-29T00:00:00.000",
                comms: 5085.0,
                total: 33.0,
                correlation: 0.3074829422,
                trend_line: 1602.0111255234,
            },
            {
                datetime: "2023-06-30T00:00:00.000",
                comms: 7010.0,
                total: 71.0,
                correlation: 0.2799405519,
                trend_line: 2816.1313845161,
            },
            {
                datetime: "2023-07-01T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.2799405519,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-02T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3459259783,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-03T00:00:00.000",
                comms: 9767.0,
                total: 10.0,
                correlation: 0.3233179783,
                trend_line: 4733.9476349123,
            },
            {
                datetime: "2023-07-04T00:00:00.000",
                comms: 9169.0,
                total: 41.0,
                correlation: 0.3264866028,
                trend_line: 4316.0074733773,
            },
            {
                datetime: "2023-07-05T00:00:00.000",
                comms: 16261.0,
                total: 184.0,
                correlation: 0.4070197274,
                trend_line: 8054.7954601236,
            },
            {
                datetime: "2023-07-06T00:00:00.000",
                comms: 14700.0,
                total: 164.0,
                correlation: 0.7485380062,
                trend_line: 7588.8860588365,
            },
            {
                datetime: "2023-07-07T00:00:00.000",
                comms: 10984.0,
                total: 15.0,
                correlation: 0.680702221,
                trend_line: 5561.3289428918,
            },
            {
                datetime: "2023-07-08T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.680702221,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-09T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.6896624007,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-10T00:00:00.000",
                comms: 6464.0,
                total: 14.0,
                correlation: 0.6864887483,
                trend_line: 2453.8083451206,
            },
            {
                datetime: "2023-07-11T00:00:00.000",
                comms: 8271.0,
                total: 56.0,
                correlation: 0.6951421552,
                trend_line: 3685.3188180996,
            },
            {
                datetime: "2023-07-12T00:00:00.000",
                comms: 15563.0,
                total: 34.0,
                correlation: 0.616092101,
                trend_line: 7883.0147359233,
            },
            {
                datetime: "2023-07-13T00:00:00.000",
                comms: 5838.0,
                total: 44.0,
                correlation: 0.6140318285,
                trend_line: 2054.2229737545,
            },
            {
                datetime: "2023-07-14T00:00:00.000",
                comms: 3900.0,
                total: 1.0,
                correlation: 0.6027133394,
                trend_line: 971.0579957563,
            },
            {
                datetime: "2023-07-15T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.6027133394,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-16T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.6981582017,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-17T00:00:00.000",
                comms: 6568.0,
                total: 2.0,
                correlation: 0.7061576492,
                trend_line: 2521.9321518998,
            },
            {
                datetime: "2023-07-18T00:00:00.000",
                comms: 5917.0,
                total: 44.0,
                correlation: 0.7223427249,
                trend_line: 2103.5750218274,
            },
            {
                datetime: "2023-07-19T00:00:00.000",
                comms: 4833.0,
                total: 68.0,
                correlation: 0.7060218895,
                trend_line: 1458.8581123336,
            },
            {
                datetime: "2023-07-20T00:00:00.000",
                comms: 5658.0,
                total: 4.0,
                correlation: 0.7060372223,
                trend_line: 1943.0484442206,
            },
            {
                datetime: "2023-07-21T00:00:00.000",
                comms: 4800.0,
                total: 72.0,
                correlation: 0.6771594824,
                trend_line: 1440.44534012,
            },
            {
                datetime: "2023-07-22T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.6771594824,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-23T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.7184763107,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-24T00:00:00.000",
                comms: 5714.0,
                total: 154.0,
                correlation: 0.6473985055,
                trend_line: 1977.4421770101,
            },
            {
                datetime: "2023-07-25T00:00:00.000",
                comms: 10146.0,
                total: 9.0,
                correlation: 0.4794951587,
                trend_line: 4995.8822036253,
            },
            {
                datetime: "2023-07-26T00:00:00.000",
                comms: 9968.0,
                total: 11.0,
                correlation: 0.2472243148,
                trend_line: 4873.2339760707,
            },
            {
                datetime: "2023-07-27T00:00:00.000",
                comms: 6463.0,
                total: 18.0,
                correlation: 0.2774610127,
                trend_line: 2453.1555152887,
            },
            {
                datetime: "2023-07-28T00:00:00.000",
                comms: 6291.0,
                total: 12.0,
                correlation: 0.2382109623,
                trend_line: 2341.5190746327,
            },
            {
                datetime: "2023-07-29T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.2382109623,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-30T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.2772590769,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-07-31T00:00:00.000",
                comms: 10767.0,
                total: 91.0,
                correlation: 0.33526186,
                trend_line: 5417.1257071342,
            },
            {
                datetime: "2023-08-01T00:00:00.000",
                comms: 5797.0,
                total: 90.0,
                correlation: 0.3875985243,
                trend_line: 2028.7421818941,
            },
            {
                datetime: "2023-08-02T00:00:00.000",
                comms: 7757.0,
                total: 104.0,
                correlation: 0.4219738373,
                trend_line: 3327.0687587018,
            },
            {
                datetime: "2023-08-03T00:00:00.000",
                comms: 5458.0,
                total: 24.0,
                correlation: 0.4160069876,
                trend_line: 1821.7021564375,
            },
            {
                datetime: "2023-08-04T00:00:00.000",
                comms: 6021.0,
                total: 76.0,
                correlation: 0.3885672361,
                trend_line: 2169.043682508,
            },
            {
                datetime: "2023-08-05T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3885672361,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-06T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4509133106,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-07T00:00:00.000",
                comms: 10614.0,
                total: 109.0,
                correlation: 0.511860854,
                trend_line: 5314.4401493913,
            },
            {
                datetime: "2023-08-08T00:00:00.000",
                comms: 7128.0,
                total: 169.0,
                correlation: 0.5030396096,
                trend_line: 2895.8201903783,
            },
            {
                datetime: "2023-08-09T00:00:00.000",
                comms: 13211.0,
                total: 55.0,
                correlation: 0.4783618585,
                trend_line: 6901.1886202513,
            },
            {
                datetime: "2023-08-10T00:00:00.000",
                comms: 5889.0,
                total: 58.0,
                correlation: 0.4849351447,
                trend_line: 2086.0451555484,
            },
            {
                datetime: "2023-08-11T00:00:00.000",
                comms: 8506.0,
                total: 70.0,
                correlation: 0.4567069284,
                trend_line: 3850.1287357223,
            },
            {
                datetime: "2023-08-12T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4567069284,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-13T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.5476784977,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-14T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.6205560022,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-08-15T00:00:00.000",
                comms: 3900.0,
                total: 0.0,
                correlation: 0.6904714342,
                trend_line: 971.0579957563,
            },
            {
                datetime: "2023-08-16T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.7067770521,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-08-17T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.7256522292,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-08-18T00:00:00.000",
                comms: 3600.0,
                total: 0.0,
                correlation: 0.7126373897,
                trend_line: 829.9903909191,
            },
            {
                datetime: "2023-08-19T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.7126373897,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-20T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.70572679,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-21T00:00:00.000",
                comms: 8366.0,
                total: 14.0,
                correlation: 0.665409173,
                trend_line: 3751.8916216789,
            },
            {
                datetime: "2023-08-22T00:00:00.000",
                comms: 12957.0,
                total: 25.0,
                correlation: 0.570504472,
                trend_line: 6764.5834879031,
            },
            {
                datetime: "2023-08-23T00:00:00.000",
                comms: 11735.0,
                total: 61.0,
                correlation: 0.5820485745,
                trend_line: 6044.9289081627,
            },
            {
                datetime: "2023-08-24T00:00:00.000",
                comms: 5722.0,
                total: 0.0,
                correlation: 0.5764084333,
                trend_line: 1982.3700435909,
            },
            {
                datetime: "2023-08-25T00:00:00.000",
                comms: 3903.0,
                total: 58.0,
                correlation: 0.5469026304,
                trend_line: 972.510008214,
            },
            {
                datetime: "2023-08-26T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.5469026304,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-27T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.5084855947,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-08-28T00:00:00.000",
                comms: 3900.0,
                total: 7.0,
                correlation: 0.6725643827,
                trend_line: 971.0579957563,
            },
            {
                datetime: "2023-08-29T00:00:00.000",
                comms: 7991.0,
                total: 25.0,
                correlation: 0.6209566322,
                trend_line: 3489.682012201,
            },
            {
                datetime: "2023-08-30T00:00:00.000",
                comms: 3994.0,
                total: 11.0,
                correlation: 0.6401485814,
                trend_line: 1016.9331892911,
            },
            {
                datetime: "2023-08-31T00:00:00.000",
                comms: 7365.0,
                total: 11.0,
                correlation: 0.615286002,
                trend_line: 3057.1307623999,
            },
            {
                datetime: "2023-09-01T00:00:00.000",
                comms: 4858.0,
                total: 107.0,
                correlation: 0.4145671529,
                trend_line: 1472.8595870045,
            },
            {
                datetime: "2023-09-02T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4145671529,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-03T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.4285160949,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-04T00:00:00.000",
                comms: 5514.0,
                total: 72.0,
                correlation: 0.4203100797,
                trend_line: 1855.4398080294,
            },
            {
                datetime: "2023-09-05T00:00:00.000",
                comms: 11059.0,
                total: 0.0,
                correlation: 0.3324164015,
                trend_line: 5610.7476964547,
            },
            {
                datetime: "2023-09-06T00:00:00.000",
                comms: 10065.0,
                total: 1.0,
                correlation: 0.2722609506,
                trend_line: 4940.1589578804,
            },
            {
                datetime: "2023-09-07T00:00:00.000",
                comms: 8013.0,
                total: 62.0,
                correlation: 0.2932301424,
                trend_line: 3505.0161868802,
            },
            {
                datetime: "2023-09-08T00:00:00.000",
                comms: 5643.0,
                total: 0.0,
                correlation: 0.254764694,
                trend_line: 1933.8662031079,
            },
            {
                datetime: "2023-09-09T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.254764694,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-10T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3003867777,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-11T00:00:00.000",
                comms: 8633.0,
                total: 0.0,
                correlation: 0.2774196388,
                trend_line: 3939.3405373029,
            },
            {
                datetime: "2023-09-12T00:00:00.000",
                comms: 4200.0,
                total: 304.0,
                correlation: 0.0592243723,
                trend_line: 1120.1494476177,
            },
            {
                datetime: "2023-09-13T00:00:00.000",
                comms: 5702.0,
                total: 3.0,
                correlation: 0.0601357289,
                trend_line: 1970.0571309322,
            },
            {
                datetime: "2023-09-14T00:00:00.000",
                comms: 5706.0,
                total: 12.0,
                correlation: 0.0592284781,
                trend_line: 1972.5179109049,
            },
            {
                datetime: "2023-09-15T00:00:00.000",
                comms: 4800.0,
                total: 9.0,
                correlation: 0.0303486971,
                trend_line: 1440.44534012,
            },
            {
                datetime: "2023-09-16T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.0303486971,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-17T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.0549893438,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-18T00:00:00.000",
                comms: 18115.0,
                total: 13.0,
                correlation: 0.0085550301,
                trend_line: 8175.1482679933,
            },
            {
                datetime: "2023-09-19T00:00:00.000",
                comms: 4763.0,
                total: 7.0,
                correlation: 0.0064963223,
                trend_line: 1419.8950662415,
            },
            {
                datetime: "2023-09-20T00:00:00.000",
                comms: 7186.0,
                total: 0.0,
                correlation: 0.0035774431,
                trend_line: 2935.1473741106,
            },
            {
                datetime: "2023-09-21T00:00:00.000",
                comms: 10996.0,
                total: 0.0,
                correlation: -0.0138570363,
                trend_line: 5569.251002443,
            },
            {
                datetime: "2023-09-22T00:00:00.000",
                comms: 11394.0,
                total: 81.0,
                correlation: 0.0104382403,
                trend_line: 5828.5836580761,
            },
            {
                datetime: "2023-09-23T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.0104382403,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-24T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.0369688432,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-09-25T00:00:00.000",
                comms: 15139.0,
                total: 3.0,
                correlation: 0.0244611595,
                trend_line: 7749.1695293536,
            },
            {
                datetime: "2023-09-26T00:00:00.000",
                comms: 7223.0,
                total: 1.0,
                correlation: 0.0346251513,
                trend_line: 2960.2875853436,
            },
            {
                datetime: "2023-09-27T00:00:00.000",
                comms: 8203.0,
                total: 427.0,
                correlation: 0.0966180727,
                trend_line: 3637.7205946957,
            },
            {
                datetime: "2023-09-28T00:00:00.000",
                comms: 4895.0,
                total: 12.0,
                correlation: 0.098549357,
                trend_line: 1493.6640188603,
            },
            {
                datetime: "2023-09-29T00:00:00.000",
                comms: 5151.0,
                total: 2.0,
                correlation: 0.0812812631,
                trend_line: 1640.2254482863,
            },
            {
                datetime: "2023-09-30T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.0812812631,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-01T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1128026484,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-02T00:00:00.000",
                comms: 5498.0,
                total: 1.0,
                correlation: 0.1777179039,
                trend_line: 1845.7811767268,
            },
            {
                datetime: "2023-10-03T00:00:00.000",
                comms: 7616.0,
                total: 137.0,
                correlation: 0.1916660522,
                trend_line: 3229.5768024606,
            },
            {
                datetime: "2023-10-04T00:00:00.000",
                comms: 8809.0,
                total: 20.0,
                correlation: 0.1852297552,
                trend_line: 4063.0533232582,
            },
            {
                datetime: "2023-10-05T00:00:00.000",
                comms: 3900.0,
                total: 98.0,
                correlation: 0.1673648625,
                trend_line: 971.0579957563,
            },
            {
                datetime: "2023-10-06T00:00:00.000",
                comms: 5253.0,
                total: 102.0,
                correlation: 0.1405413875,
                trend_line: 1699.8515743157,
            },
            {
                datetime: "2023-10-07T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.1405413875,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-08T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.2392127984,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-09T00:00:00.000",
                comms: 7629.0,
                total: 273.0,
                correlation: 0.2628785946,
                trend_line: 3238.5480884583,
            },
            {
                datetime: "2023-10-10T00:00:00.000",
                comms: 7381.0,
                total: 328.0,
                correlation: 0.2912344448,
                trend_line: 3068.0768970608,
            },
            {
                datetime: "2023-10-11T00:00:00.000",
                comms: 10517.0,
                total: 0.0,
                correlation: 0.2965955524,
                trend_line: 5248.9394344881,
            },
            {
                datetime: "2023-10-12T00:00:00.000",
                comms: 8315.0,
                total: 0.0,
                correlation: 0.2796554069,
                trend_line: 3716.1423873119,
            },
            {
                datetime: "2023-10-13T00:00:00.000",
                comms: 7394.0,
                total: 30.0,
                correlation: 0.2448597807,
                trend_line: 3076.9755409457,
            },
            {
                datetime: "2023-10-14T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.2448597807,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-15T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3989082552,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-16T00:00:00.000",
                comms: 7558.0,
                total: 35.0,
                correlation: 0.4077370813,
                trend_line: 3189.5964394661,
            },
            {
                datetime: "2023-10-17T00:00:00.000",
                comms: 8015.0,
                total: 4.0,
                correlation: 0.3289935112,
                trend_line: 3506.4105552374,
            },
            {
                datetime: "2023-10-18T00:00:00.000",
                comms: 13950.0,
                total: 157.0,
                correlation: 0.3963718265,
                trend_line: 7268.3160064497,
            },
            {
                datetime: "2023-10-19T00:00:00.000",
                comms: 10681.0,
                total: 79.0,
                correlation: 0.393654305,
                trend_line: 5359.5047877069,
            },
            {
                datetime: "2023-10-20T00:00:00.000",
                comms: 6229.0,
                total: 1.0,
                correlation: 0.3610543739,
                trend_line: 2301.6053959769,
            },
            {
                datetime: "2023-10-21T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3610543739,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-22T00:00:00.000",
                comms: 0.0,
                total: 0.0,
                correlation: 0.3876820573,
                trend_line: -58.7325405765,
            },
            {
                datetime: "2023-10-23T00:00:00.000",
                comms: 6658.0,
                total: 119.0,
                correlation: 0.3803894261,
                trend_line: 2581.2421102828,
            },
            {
                datetime: "2023-10-24T00:00:00.000",
                comms: 17171.0,
                total: 180.0,
                correlation: 0.472571023,
                trend_line: 8179.0341570481,
            },
            {
                datetime: "2023-10-25T00:00:00.000",
                comms: 13223.0,
                total: 65.0,
                correlation: 0.4571659125,
                trend_line: 6907.5175415811,
            },
            {
                datetime: "2023-10-26T00:00:00.000",
                comms: 4382.0,
                total: 0.0,
                correlation: 0.4707408124,
                trend_line: 1214.3013870965,
            },
        ],
        explanation:
            "This is the graph is showing the correlation between time spent on communications a day and the lines of code committed that day.\n            Any data points above the 0.2 and below the -0.2 lines have a statistically significant correlation.\n            ",
        description:
            "It has been produced by calculating the correlation coefficient on a rolling window of 20 days, in order to smoothen the curve and depict the general direction of the move while minimizing the noise. This means that we take a window of the 20 first days of data and we calculate the correlation coefficient, then we remove the oldest day and we add an earlier one, calculating again the correlation, and we keep doing that until we reach the end of the dataset, meaning yesterday.\n            \n            These have been the best settings we have found to be working better for this calculation. However, we will allow you to set this settings in any value you see more fit.\n            \n            Any data points above the 0.2 line have a statistically significant positive correlation, meaning when one of the variable increases the other one does too. Also any data points below -0.2 represent a\n            statistically significant negative correlation, meaning when one variable increases the other one does reduce. The higher or lower from 0 a data point is the more positively or negatively our two variables are correlated indicatign that they potentially affect each other more.\n            ",
        error: null,
    },
};

export default commsToLinesResp;
